import * as angular from 'angular';

angular.module('app').controller('McpHelpController', mcpHelp);

function mcpHelp($scope, $http) {
	$scope.mcpUrl = '';
	$scope.configJson = '';
	$scope.loadError = null;
	$scope.tools = [];

	$http
		.get('/proxy/mcp/help')
		.then(response => {
			const mcpUrl = response.data.mcpUrl;
			$scope.mcpUrl = mcpUrl;
			$scope.configJson = JSON.stringify(
				{
					servers: {
						amber: {
							type: 'http',
							url: mcpUrl,
						},
					},
				},
				null,
				2
			);
			$scope.tools = response.data.tools;
		})
		.catch(() => {
			$scope.loadError = 'Unable to load MCP help details.';
		});
}
